import { render, staticRenderFns } from "./DeleteQuerylogsForm.vue?vue&type=template&id=ccae03e0&"
import script from "./DeleteQuerylogsForm.vue?vue&type=script&lang=js&"
export * from "./DeleteQuerylogsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports